/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './paper.module.css';

const Paper = ({ children, padding, className = '', ...props }) => (
  <div
    className={classnames(styles.block, className)}
    style={{ padding }}
    {...props}
  >
    {children}
  </div>
);

Paper.defaultProps = {
  padding: 10,
};

Paper.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.number,
};

export default Paper;
